const config = require("../config.js");
const gameModes = require("./gameModes.js");
const UTILS = require("../libs/utils.js");
const prefabs = new (require("./prefabs.js"))();
const triggers = require("./triggers.js");
const classes = require("./classes.js");
const vLN15000 = 15000;
function f2103(p16549) {
  if (p16549.modes) {
    for (var vLN02405 = 0; vLN02405 < p16549.modes.length; ++vLN02405) {
      if (!gameModes[p16549.modes[vLN02405]]) {
        return "Invalid Mode in Config.";
      }
    }
  }
  return null;
}
function f2104(p16550) {
  if (p16550.classes) {
    for (var vLN02406 = 0; vLN02406 < p16550.classes.length; ++vLN02406) {
      if (!classes[p16550.classes[vLN02406]]) {
        return "Invalid Class in Config.";
      }
    }
  }
  return null;
}
function f2105(p16551) {
  if (p16551.settings) {
    var vLN02407 = 0;
    for (var v13403 in p16551.settings) {
      if (p16551.settings.hasOwnProperty(v13403)) {
        var v13404 = p16551.settings[v13403];
        var v13405 = -1;
        for (var vLN02408 = 0; vLN02408 < config.serverConfig.length; ++vLN02408) {
          if (config.serverConfig[vLN02408].varN == v13403) {
            v13405 = vLN02408;
            break;
          }
        }
        if (v13405 < 0) {
          return "Invalid Setting in Config.";
        }
        var v13406 = config.serverConfig[v13405];
        if (!v13406.input && !v13406.bool) {
          if (!UTILS.isNumber(v13404)) {
            return "Invalid Config Value. (Set: " + v13406.name + ")";
          }
          if (v13406.select ? v13406.options[v13404] == null : v13404 > (v13406.maxD || v13406.maxF || v13406.max) || v13404 < v13406.min) {
            return "Config Value out of Range. (Set: " + v13406.name + ")";
          }
        }
        vLN02407++;
        if (vLN02407 > config.serverConfig.length + 1) {
          return "Settings Mismatch.";
        }
      }
    }
  }
  return null;
}
function f2106(p16552) {
  let v13407 = null;
  v13407 = f2103(p16552);
  if (v13407) {
    return v13407;
  } else {
    v13407 = f2104(p16552);
    if (v13407) {
      return v13407;
    } else {
      v13407 = f2105(p16552);
      if (v13407) {
        return v13407;
      } else {
        v13407 = f2107(p16552);
        if (v13407) {
          return v13407;
        } else {
          return null;
        }
      }
    }
  }
}
function f2107(p16553) {
  let v13408 = null;
  v13408 = f2108(p16553.weps, "weaponConfig");
  if (v13408) {
    return v13408;
  } else {
    v13408 = f2108(p16553.cls, "classConfig");
    if (v13408) {
      return v13408;
    } else {
      v13408 = f2108(p16553.prks, "effectConfig");
      if (v13408) {
        return v13408;
      } else {
        return null;
      }
    }
  }
}
function f2108(p16554, p16555) {
  p16555 = p16555 || "weaponConfig";
  if ((p16554 + "").length >= vLN15000) {
    return p16555 + " - Too much data.";
  }
  if (p16554) {
    for (var v13409 in p16554) {
      for (var v13410 in p16554[v13409]) {
        var v13411 = p16554[v13409][v13410];
        var v13412 = -1;
        for (var vLN02409 = 0; vLN02409 < config[p16555].length; ++vLN02409) {
          if (config[p16555][vLN02409].varN == v13410) {
            v13412 = vLN02409;
            break;
          }
        }
        if (v13412 < 0) {
          return "Invalid Setting in " + p16555 + ". (ID: " + v13409 + ")";
        }
        var v13413 = config[p16555][v13412];
        if (v13413.input) {
          if (!UTILS.isString(v13411)) {
            return "Invalid " + p16555 + " Value. (ID: " + v13409 + ", Set: " + v13413.name + ")";
          }
          if (/[^\w \-\|]+/gmi.test(v13411)) {
            return "Invalid " + p16555 + " Value. (ID: " + v13409 + ", Set: " + v13413.name + ")";
          }
          if (v13411.length > (v13413.len || 16)) {
            return "Invalid " + p16555 + " Value. (ID: " + v13409 + ", Set: " + v13413.name + ")";
          }
        } else if (v13413.select) {
          if (v13413.options[v13411] == null) {
            return "Config Value out of Range. (ID: " + v13409 + ", Set: " + v13413.name + ")";
          }
        } else if (!v13413.bool) {
          if (!UTILS.isNumber(v13411)) {
            return "Invalid " + p16555 + " Value. (ID: " + v13409 + ", Set: " + v13413.name + ")";
          }
          if (v13411 > (v13413.maxD || v13413.maxF || v13413.max) || v13411 < v13413.min) {
            return p16555 + " Value out of Range. (ID: " + v13409 + ", Set: " + v13413.name + ")";
          }
        }
      }
    }
  }
  return null;
}
function f2109(p16556, p16557, p16558) {
  if (!p16558) {
    if (!UTILS.isString(p16556.name) || !p16556.name.replace(/\s/g, "").length) {
      return "Missing map name.";
    }
    if (p16556.name.indexOf("<") !== -1 || p16556.name.indexOf(">") !== -1) {
      return "Illegal characters in map name.";
    }
    if (p16556.name.length > 16) {
      return "Map name too long.";
    }
    if (!p16556.tris || !UTILS.isArray(p16556.tris)) {
      delete p16556.tris;
    } else if (p16556.tris.length / 9 >= config.triangleLimit) {
      return "Complex Collisions exceeds limits.";
    }
    if (!UTILS.isArray(p16556.spawns) || !p16556.spawns.length) {
      return "Missing spawn points.";
    }
    if (p16556.spawns.length > config.spawnLimit) {
      return "Too many spawn points.";
    }
    var v13414;
    for (var vLN02417 = 0; vLN02417 < p16556.spawns.length; ++vLN02417) {
      v13414 = p16556.spawns[vLN02417];
      if (!UTILS.isArray(v13414) || !v13414.length || v13414.length < 3 || v13414.length > 8) {
        return "Spawn point error.";
      }
      for (var vLN02418 = 0; vLN02418 < v13414.length; ++vLN02418) {
        if (vLN02418 < 3 && !UTILS.isNumber(v13414[vLN02418])) {
          return "Spawn point error.";
        }
        if (vLN02418 == 3 && v13414[vLN02418] == null && v13414[vLN02418] == 1 && v13414[vLN02418] == 2) {
          return "Spawn team error.";
        }
      }
    }
    if (p16556.welMsg) {
      if (p16556.welMsg && UTILS.isString(p16556.welMsg) && p16556.welMsg != "") {
        if (p16556.welMsg.length > 70) {
          return "Welcome Message too Long";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(p16556.welMsg)) {
          return "Illegal characters in Welcome Message";
        }
      } else {
        p16556.welMsg = "";
      }
    }
  }
  if (!UTILS.isArray(p16556.objects) || !p16556.objects.length) {
    return "Missing objects.";
  }
  if (p16556.objects.length > (p16557 ? config.objectLimitF : config.objectLimit)) {
    return "Map exceeds overall object limit.";
  }
  var vLN02412 = 0;
  var vLN02413 = 0;
  var vLN02414 = 0;
  var vLN02415 = 0;
  var vO426 = {};
  var vLN02416 = 0;
  var v13415 = p16557 ? config.objectColLimitF : config.objectColLimit;
  var vA743 = ["s"];
  var v13416 = p16556.xyz || [];
  for (var vLN02417 = 0; vLN02417 < p16556.objects.length; ++vLN02417) {
    var v13417 = p16556.objects[vLN02417];
    var v13418 = v13417.s || v13417.si;
    for (var vLN02418 = 0; vLN02418 < vA743.length; vLN02418++) {
      if (v13417[vA743[vLN02418] + "i"] != null) {
        var v13419 = v13417[vA743[vLN02418] + "i"] * 3;
        if (v13417[vA743[vLN02418] + "i"] != null && v13419 != null && v13416.length > v13419) {
          v13418 = v13416.slice(v13419, v13419 + 3);
        }
      }
    }
    if (!prefabs.prefabs[v13417.i || 0]) {
      return "Invalid Object.";
    }
    if (!prefabs.prefabs[v13417.i || 0].noCol && v13417.l == null && v13417.col == null) {
      vLN02416++;
    }
    if (vLN02416 > v13415) {
      return "Map exceeds collidable object limit.";
    }
    if (prefabs.prefabs[v13417.i || 0].name == "SIGN") {
      vLN02412++;
      if (v13417.st != null && typeof v13417.st != "string") {
        return "Object sign text error.";
      }
      if ((v13417.st || "").length > config.signTextLimit) {
        return "Object sign text to long.";
      }
      if (vLN02412 > config.signLimit) {
        return "Too many signs.";
      }
      if (v13417.sf && v13417.sf > config.signFontMax || v13417.sf && v13417.sf < config.signFontMin) {
        return "Object sign font error.";
      }
    }
    if (prefabs.prefabs[v13417.i || 0].name == "PRIZE_WHEEL" && (vLN02413++, vLN02413 > config.wheelLimit)) {
      return "Too many Prize Wheels.";
    }
    if (prefabs.prefabs[v13417.i || 0].name == "LEADERBOARD" && (vLN02414++, vLN02414 > config.lbLimit)) {
      return "Too many Leaderboards.";
    }
    if (prefabs.prefabs[v13417.i || 0].ai && (vLN02415++, vLN02415 > config.aiLimit)) {
      return "Too many AI.";
    }
    if (v13417.tas && Array.isArray(v13417.tas)) {
      if (v13417.tas.length > config.triggerActionLimit) {
        return "Trigger Has Too Many Actions";
      }
      for (var vLN02419 = 0; vLN02419 < v13417.tas.length; vLN02419++) {
        if (v13417.tas[vLN02419].tct) {
          if (v13417.tas[vLN02419].tct && UTILS.isString(v13417.tas[vLN02419].tct) && v13417.tas[vLN02419].tct != "") {
            if (v13417.tas[vLN02419].tct.length > 70) {
              return "Trigger Message too Long";
            }
            if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(v13417.tas[vLN02419].tct)) {
              return "Illegal characters in Trigger Message";
            }
          } else {
            v13417.tas[vLN02419].tct = "";
          }
        }
        if (v13417.tas[vLN02419].tcc) {
          if (v13417.tas[vLN02419].tcc && UTILS.isString(v13417.tas[vLN02419].tcc) && v13417.tas[vLN02419].tcc != "") {
            if (v13417.tas[vLN02419].tcc.length > 70) {
              return "Trigger Custom Key too Long";
            }
            if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(v13417.tas[vLN02419].tcc)) {
              return "Illegal characters in Trigger Custom Key";
            }
          } else {
            v13417.tas[vLN02419].tcc = "";
          }
        }
        if (v13417.tas[vLN02419].cd) {
          var v13420 = triggers.conditions[v13417.tas[vLN02419].cd || 0];
          if (v13420 && v13420.vals) {
            var v13421;
            for (var vLN02420 = 0; vLN02420 < v13420.vals.length; vLN02420++) {
              v13421 = v13417.tas[vLN02419]["cv" + vLN02420];
              if (v13421 == null) {
                v13421 = v13420.vals[vLN02420].def;
              }
              if (v13420.vals[vLN02420].input) {
                v13421 += "";
                if (!UTILS.isString(v13421)) {
                  return "CONDITION VALUE MUST BE STRING (" + v13420.vals[vLN02420].name + ")";
                }
                if (/[^a-z0-9_]+/gmi.test(v13421)) {
                  return "INVALID CHARACTERS IN CONDITION VALUE (" + v13420.vals[vLN02420].name + ")";
                }
                if ((v13421 || "").toString().length > (v13420.vals[vLN02420].len || 10)) {
                  return "CONDITION VALUE TOO LONG (" + v13420.vals[vLN02420].name + ")";
                }
              } else if (v13420.vals[vLN02420].select) {
                if (!UTILS.isNumber(parseInt(v13421)) || v13420.vals[vLN02420].select[v13421] == null) {
                  return "CONDITION VALUE OPTION DOESNT EXIST (" + v13420.vals[vLN02420].name + ")";
                }
              } else if (!v13420.vals[vLN02420].bool) {
                if (!UTILS.isNumber(parseInt(v13421))) {
                  return "CONDITION VALUE MUST BE A NUMBER(" + v13420.vals[vLN02420].name + ")";
                }
                if (v13421 > v13420.vals[vLN02420].max || v13421 < v13420.vals[vLN02420].min) {
                  return "CONDITION VALUE OUT OF RANGE (" + v13420.vals[vLN02420].name + ")";
                }
              }
              v13417.tas[vLN02419]["cv" + vLN02420] = v13421;
            }
          } else if (!v13420) {
            return "INVALID CONDITION";
          }
        }
      }
    }
    if (v13417.tct) {
      if (v13417.tct && UTILS.isString(v13417.tct) && v13417.tct != "") {
        if (v13417.tct.length > 70) {
          return "Trigger Message too Long";
        }
        if (/[^\w\:\;\(\)\?\,\.\|\[\] \-\+*\$\@\=\^!{}]+/gmi.test(v13417.tct)) {
          return "Illegal characters in Trigger Message";
        }
      } else {
        v13417.tct = "";
      }
    }
    if (parseInt(v13417.in) && (vO426[parseInt(v13417.in)] ? vO426[parseInt(v13417.in)]++ : vO426[parseInt(v13417.in)] = 1, vO426[parseInt(v13417.in)] > config.interfaceLimit)) {
      return "Interface limit Exceeded: Max 20 (Per id)";
    }
    if (!UTILS.isArray(v13418) || v13418.length != 3 || !UTILS.arrayInts(v13418)) {
      return "Object scale error.";
    }
    if (!UTILS.isArray(v13417.p) || v13417.p.length != 3 || !UTILS.arrayInts(v13417.p)) {
      return "Object position error.";
    }
    if (UTILS.isArray(v13417.r)) {
      if (v13417.r.length != 3 || !UTILS.arrayInts(v13417.r)) {
        return "Object rotation value error.";
      }
    } else if (v13417.r != null) {
      return "Object rotation error.";
    }
    if (v13417.d != null && !UTILS.isNumber(v13417.d)) {
      return "Object direction error.";
    }
    v13417.col = !!v13417.col;
  }
  if (!p16558 && p16556.gui && p16556.gui.length > (p16557 ? config.guiLimitF : config.guiLimit)) {
    return "Map exceeds gui limit.";
  } else {
    return null;
  }
}
function f2110(p16559, p16560, p16561, p16562) {
  var v13422 = config.hostTypes[p16559] || {};
  var vO427 = {};
  for (var vLN02422 = 0; vLN02422 < config.serverConfig.length; vLN02422++) {
    if (config.serverConfig[vLN02422].hostTypes == null || config.serverConfig[vLN02422].hostTypes.includes(p16559 || 0)) {
      if ((config.serverConfig[vLN02422].hostTypes || [0]).includes(p16559 || 0)) {
        if (!vO427[p16559 || 0]) {
          vO427[p16559 || 0] = {};
        }
        vO427[p16559 || 0][config.serverConfig[vLN02422].varN] = p16560[config.serverConfig[vLN02422].varN];
      }
    } else {
      p16560[config.serverConfig[vLN02422].varN] = config.serverConfig[vLN02422].def;
    }
  }
  var v13423 = p16560.maps;
  if (v13422.overDat) {
    p16560 = v13422.overDat;
  }
  if (vO427[p16559]) {
    for (var v13426 in vO427[p16559]) {
      p16560[v13426] = vO427[p16559][v13426];
    }
  }
  if (p16561) {
    for (var v13426 in p16561) {
      p16560[v13426] = p16561[v13426];
    }
  }
  if (v13422.comp) {
    p16560.minPlayers = ((p16560.tmSize || 0) + 1) * 2;
    p16560.maxPlayers = p16560.minPlayers + (p16560.specSlots || 0);
    p16560.isComp = true;
  }
  p16560.maps = v13423;
  p16560.modes = (p16560.modes || []).filter(function (p16563) {
    return gameModes[p16563] && (p16562 || !gameModes[p16563].preventCustomGames);
  });
  p16560.mimicPubs = false;
  let vP16560 = p16560;
  if (v13422.forceDat) {
    p16560 = v13422.forceDat;
  }
  if (v13422.allowedDat) {
    for (var v13426 in v13422.allowedDat) {
      if (Array.isArray(v13422.allowedDat[v13426])) {
        let v13427 = true;
        if (!vP16560[v13426] || !vP16560[v13426].length) {
          v13427 = false;
        }
        if (v13427) {
          let vA744 = [];
          for (var vLN02422 = 0; vLN02422 < vP16560[v13426].length; vLN02422++) {
            if (v13422.allowedDat[v13426].includes(vP16560[v13426][vLN02422])) {
              vA744.push(vP16560[v13426][vLN02422]);
            }
          }
          if (vA744.length) {
            vP16560[v13426] = vA744;
          } else {
            v13427 = false;
          }
        }
        p16560[v13426] = v13427 ? vP16560[v13426] : v13422.allowedDat[v13426].slice(0, 1);
      } else {
        p16560[v13426] = v13422.allowedDat[v13426];
      }
    }
  }
  if (p16560.krRewards && !p16560.customMap) {
    p16560.krRewards = false;
  }
  if (p16560.krRewards && p16560.rawMapData) {
    p16560.krRewards = false;
  }
  if (!p16560.defaultSetts) {
    p16560.krRewards = false;
  }
  return p16560;
}
module.exports = {
  validateMap: f2109,
  validateConfigs: f2106,
  validateCustomConfig: f2108,
  validateCustomConfigs: f2107,
  setupGameConfig: f2110
};